import {EnvironmentInterface} from '../app/core/types/environement/environment.interface';

export const environment:EnvironmentInterface = {
  production: false,
  stage: true,
  apiDomain: 'https://api.scu.ovdal.dk',
  host: 'https://scu.ovdal.dk',
  imageDomain: 'https://api.scu.ovdal.dk',
  fileDomain: 'https://scu.ovdal.dk',
  adminEmail:'admin@admin.admin',
  itemsPerPage:10
};
